/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function () {
  // toggle .scroll-to-fixed-fixed on .nav-bar when scrolling, if user is not at the top of the page, add class .scroll-to-fixed-fixed:
  var navBar = document.querySelector(".nav-bar");

  if (navBar) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 0) {
        navBar.classList.add("scroll-to-fixed-fixed");
      } else {
        navBar.classList.remove("scroll-to-fixed-fixed");
      }
    });
  }

  // find .n_icon a.signin, toggle .active on this .n_icon when clicking on it:
  var allNIcons = document.querySelectorAll(".n_icon");
  allNIcons.forEach(function (nIcon) {
    var toggleBtn = nIcon.querySelector("a.signin");
    if (!toggleBtn) toggleBtn = nIcon.querySelector("a.search");

    if (toggleBtn) {
      toggleBtn.addEventListener("click", function (event) {
        event.preventDefault();
        nIcon.classList.toggle("active");
        // if navVar doesn't have .scroll-to-fixed-fixed, add it:
        if (!navBar.classList.contains("scroll-to-fixed-fixed"))
          navBar.classList.add("scroll-to-fixed-fixed");
        if (nIcon.querySelector("a.search")) {
          navBar.classList.toggle("nav-bar--search-active");
        }
      });
    }
    // try to find .close and remove .active from .n_icon when clicking on it:
    var closeButton = nIcon.querySelector(".close");
    if (!closeButton) closeButton = nIcon.querySelector(".search_close");
    if (closeButton) {
      closeButton.addEventListener("click", function (event) {
        event.preventDefault();
        nIcon.classList.remove("active");
      });
    }
  });

  // find .mobile-login btn, and if we click it, use js to click on the .n_icon a.signin:
  var mobileLoginBtn = document.querySelector(".mobile-login");
  if (mobileLoginBtn) {
    mobileLoginBtn.addEventListener("click", function (event) {
      event.preventDefault();
      const loginBtn = document.querySelector(".n_icon a.signin");
      if (loginBtn) loginBtn.click();
    });
  }

  // find all .product-list--grid:
  const allFeatureCol = document.querySelectorAll(".feature-collections");
  // check if we have .product-list--grid__show-more-btn:
  allFeatureCol.forEach(function (collection) {
    // check if has .product-list--grid, if not, return
    if (!collection.querySelector(".product-list--grid")) return;
    const showMoreBtn = collection.querySelector(
      ".product-list--grid__show-more-btn"
    );
    if (showMoreBtn) {
      showMoreBtn.addEventListener("click", function (event) {
        event.preventDefault();
        const hiddenProducts = collection.querySelectorAll(".custom-hidden");
        // show the next 8 hidden products, if all products are shown, hide the show more button::
        for (let i = 0; i < 8; i++) {
          if (hiddenProducts[i]) {
            hiddenProducts[i].classList.remove("custom-hidden");
          } else {
            showMoreBtn.style.display = "none";
            break;
          }
        }
      });
    }
  });
});

class CartAnnouncementCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.innerHTML = `
      <div class="swiper-container">
        <div class="swiper-wrapper">
          ${this.innerHTML}
        </div>
        <div class="swiper-button-prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" viewBox="0 0 54 96"><path d="M6.1 95.5c-1.4 0-2.9-.5-4-1.6-2.2-2.2-2.2-5.7 0-7.9L40 48 2.1 10.1c-2.2-2.2-2.2-5.7 0-7.9S7.8 0 10 2.1L51.9 44c1.1 1.1 1.6 2.5 1.6 4s-.6 2.9-1.6 4L10 93.9c-1.1 1.1-2.5 1.6-3.9 1.6z" fill="currentColor"/></svg>
        </div>
        <div class="swiper-button-next">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" viewBox="0 0 54 96"><path d="M6.1 95.5c-1.4 0-2.9-.5-4-1.6-2.2-2.2-2.2-5.7 0-7.9L40 48 2.1 10.1c-2.2-2.2-2.2-5.7 0-7.9S7.8 0 10 2.1L51.9 44c1.1 1.1 1.6 2.5 1.6 4s-.6 2.9-1.6 4L10 93.9c-1.1 1.1-2.5 1.6-3.9 1.6z" fill="currentColor"/></svg>
        </div>
      </div>
    `;
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper-container"), {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

customElements.define("cart-announcement-carousel", CartAnnouncementCarousel);

// class CartDiscountElement extends HTMLElement {
//   constructor() {
//     super();
//     this.shopDomain = this.dataset.shopDomain;
//     this.discountUrl = `https://${this.shopDomain}/discount/`;
//     this.discountCode = "";
//   }

//   connectedCallback() {
//     this.attachEventListeners();
//   }

//   attachEventListeners() {
//     this.querySelector(".cart-discount__button").addEventListener("click", () =>
//       this.applyDiscount()
//     );
//     this.querySelector(".cart-discount__remove").addEventListener("click", () =>
//       this.removeDiscount()
//     );
//   }

//   updateCartWithDiscount() {
//     document.documentElement.dispatchEvent(
//       new CustomEvent("cart:refresh", {
//         bubbles: true,
//       })
//     );
//   }

//   async applyDiscount() {
//     const codeInput = this.querySelector(".cart-discount__field");
//     const code = codeInput.value.trim();
//     if (!code) return;

//     await this.sendDiscountRequest(code);

//     this.updateCartWithDiscount();
//   }

//   async removeDiscount() {
//     await this.sendDiscountRequest("");

//     this.updateCartWithDiscount(response);
//   }

//   sendDiscountRequest(code) {
//     return fetch(this.discountUrl + code, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });
//   }
// }

// customElements.define("cart-discount", CartDiscountElement);

class CoBuyCarousel extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
  }

  connectedCallback() {
    this.carouselInner = this.querySelector(".co-buy-carousel-inner");
    if (!this.carouselInner) {
      console.warn("Carousel inner container not found");
      return;
    }

    this.slides = this.carouselInner.querySelectorAll(".co-buy-picks__slide");
    if (this.slides.length === 0) {
      console.warn("No slides found in the carousel");
      return;
    }

    this.prevButton = this.querySelector(".co-buy-prev");
    this.nextButton = this.querySelector(".co-buy-next");

    this.setupEventListeners();
    this.updateCarouselHeight();
    this.showSlide(0); // Show the first slide initially
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    this.boundShowPrevSlide = this.showPrevSlide.bind(this);
    this.boundShowNextSlide = this.showNextSlide.bind(this);

    if (this.prevButton) {
      this.prevButton.addEventListener("click", this.boundShowPrevSlide);
    }
    if (this.nextButton) {
      this.nextButton.addEventListener("click", this.boundShowNextSlide);
    }
    window.addEventListener("resize", this.updateCarouselHeight.bind(this));

    // Add event listeners for add to cart buttons
    this.querySelectorAll(".co-buy-picks__add-button").forEach((button) => {
      button.addEventListener("click", this.handleAddToCart.bind(this));
    });

    // Add event listeners for variant selects
    this.querySelectorAll(".co-buy-picks__variant-select").forEach((select) => {
      select.addEventListener("change", this.handleVariantChange.bind(this));
    });
  }

  removeEventListeners() {
    if (this.prevButton) {
      this.prevButton.removeEventListener("click", this.boundShowPrevSlide);
    }
    if (this.nextButton) {
      this.nextButton.removeEventListener("click", this.boundShowNextSlide);
    }
    window.removeEventListener("resize", this.updateCarouselHeight);

    // Remove event listeners for add to cart buttons
    this.querySelectorAll(".co-buy-picks__add-button").forEach((button) => {
      button.removeEventListener("click", this.handleAddToCart);
    });

    // Remove event listeners for variant selects
    this.querySelectorAll(".co-buy-picks__variant-select").forEach((select) => {
      select.removeEventListener("change", this.handleVariantChange);
    });
  }

  updateCarouselHeight() {
    if (this.slides && this.slides.length > 0) {
      const activeSlide = this.slides[this.currentIndex];
      this.style.height = `${activeSlide.offsetHeight}px`;
    }
  }

  showSlide(index) {
    if (!this.slides || this.slides.length === 0) return;

    if (index < 0) index = this.slides.length - 1;
    if (index >= this.slides.length) index = 0;

    this.carouselInner.style.transform = `translateX(-${index * 100}%)`;

    this.currentIndex = index;
    this.updateCarouselHeight();
  }

  showPrevSlide() {
    this.showSlide(this.currentIndex - 1);
  }

  showNextSlide() {
    this.showSlide(this.currentIndex + 1);
  }

  handleVariantChange(event) {
    const select = event.target;
    const variantId = select.value;
    const slide = select.closest(".co-buy-picks__slide");

    // Update image
    const images = slide.querySelectorAll(".co-buy-picks__image");
    images.forEach((img) => {
      if (img.dataset.variantId === variantId) {
        img.style.display = "block";
      } else {
        img.style.display = "none";
      }
    });

    // Update price
    const priceContainers = slide.querySelectorAll(
      ".co-buy-picks__price-container"
    );
    priceContainers.forEach((container) => {
      if (container.dataset.variantId === variantId) {
        container.style.display = "flex";
      } else {
        container.style.display = "none";
      }
    });

    // Update buttons
    const selectedOption = select.querySelector(`option[value="${variantId}"]`);
    const isAvailable = !selectedOption.disabled;
    const buttons = slide.querySelectorAll(".co-buy-picks__add-button");
    buttons.forEach((button) => {
      button.setAttribute("data-variant-id", variantId);
      if (isAvailable) {
        button.textContent = "ADD";
        button.disabled = false;
      } else {
        button.textContent = "Sold Out";
        button.disabled = true;
      }
    });
  }

  async handleAddToCart(event) {
    const button = event.target;
    const variantId = button.getAttribute("data-variant-id");
    const originalText = button.textContent;

    // Set loading state
    button.textContent = "Adding...";
    button.disabled = true;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      button.textContent = "Added";
      setTimeout(() => {
        // cart refresh:
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
      }, 500);
    } catch (error) {
      console.error("Error adding product to cart:", error);
      button.textContent = "Error";
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  }
}

customElements.define("co-buy-carousel", CoBuyCarousel);

// locale form:
document.addEventListener("DOMContentLoaded", function () {
  const localizationForms = document.querySelectorAll(
    ".localization-custom-form"
  );

  localizationForms.forEach(function (form) {
    form.querySelectorAll("select").forEach(function (select) {
      select.addEventListener("change", function () {
        form.submit();
      });
    });
  });
});

// For the desktop menu:
document.addEventListener("DOMContentLoaded", () => {
  const menuIds = Array.from({ length: 11 }, (_, i) => `desktop-menu-0-${i}`);

  menuIds.forEach((menuId) => {
    const menu = document.getElementById(menuId);
    if (!menu) return;

    const leftItems = menu.querySelectorAll(".inner-tab_left ul li");
    const rightColumns = menu.querySelectorAll(
      ".inner-tab_right .mega-menu__column"
    );

    leftItems.forEach((item, index) => {
      item.addEventListener("mouseover", () => {
        rightColumns.forEach((col) => (col.style.display = "none"));
        rightColumns[index].style.display = "block";

        leftItems.forEach((li) => li.classList.remove("active"));
        item.classList.add("active");
      });
    });
  });
});

// Product gallery custom code:
class SubProductGallery extends HTMLElement {
  constructor() {
    super();
    this.galleryWrapper = this.querySelector(
      ".product-gallery__carousel-wrapper"
    );
    this.prevButton = this.galleryWrapper.querySelector(".gallery-arrow--prev");
    this.nextButton = this.galleryWrapper.querySelector(".gallery-arrow--next");
    this.thumbnailList = this.querySelector(".product-gallery__thumbnail-list");
    this.thumbnails = Array.from(
      this.thumbnailList.querySelectorAll(".product-gallery__thumbnail")
    );
    this.currentIndex = this.thumbnails.findIndex((thumb) =>
      thumb.classList.contains("is-nav-selected")
    );

    this.init();
  }

  init() {
    this.updateButtonVisibility(this.currentIndex);
    this.addEventListeners();
  }

  addEventListeners() {
    this.prevButton.addEventListener("click", () => this.navigate(-1));
    this.nextButton.addEventListener("click", () => this.navigate(1));
  }

  navigate(direction) {
    let newIndex = this.currentIndex + direction;
    if (newIndex < 0) newIndex = this.thumbnails.length - 1;
    if (newIndex >= this.thumbnails.length) newIndex = 0;
    this.updateGallery(newIndex);
  }

  updateGallery(newIndex) {
    this.thumbnails[this.currentIndex].classList.remove("is-nav-selected");
    this.thumbnails[newIndex].classList.add("is-nav-selected");
    this.thumbnails[newIndex].click(); // Trigger the click event on the thumbnail
    this.currentIndex = newIndex;
    this.updateButtonVisibility(this.currentIndex);
  }

  updateButtonVisibility(index) {
    this.prevButton.style.display = index === 0 ? "none" : "block";
    this.nextButton.style.display =
      index === this.thumbnails.length - 1 ? "none" : "block";
  }
}

customElements.define("sub-product-gallery", SubProductGallery);

function handleDesktopProductBlockStickyOrNot() {
  if (window.innerWidth < 999) return;

  const productBlockList = document.querySelector(".product-block-list");
  if (!productBlockList) return;

  const leftCard = productBlockList.querySelector("sub-product-gallery .card");
  const rightCard = productBlockList.querySelector(
    ".product-block-list__item--info .card"
  );
  if (!leftCard || !rightCard) return;

  // Compare the height with a threshold:
  const heightThreshold = 70; // Adjust this value as needed
  const leftHeight = leftCard.getBoundingClientRect().height;
  const rightHeight = rightCard.getBoundingClientRect().height;
  const heightDifference = Math.abs(leftHeight - rightHeight);

  if (leftHeight < rightHeight && heightDifference > heightThreshold) {
    // If left side is shorter than the right side by more than the threshold
    productBlockList.classList.add("left-card--sticky");
  } else if (leftHeight >= rightHeight && heightDifference > heightThreshold) {
    // If left side is taller than or equal to the right side by more than the threshold
    productBlockList.classList.remove("left-card--sticky");
  }
  // If the height difference is within the threshold, do nothing
}

// Use requestAnimationFrame instead of setInterval for smoother performance
function checkStickyState() {
  handleDesktopProductBlockStickyOrNot();
  requestAnimationFrame(checkStickyState);
}

checkStickyState();
